import { Mentions } from "@/shared/form/mention";
import { MentionProps } from "@/shared/form/mention";
import { PREFIX } from "@/shared/template-properties/model/prefix";
import { useMemo } from "react";

type MentionParamsProps = MentionProps & {
  properties: string[];
};

export function PropertyInput({ properties, ...rest }: MentionParamsProps) {
  const options = useMemo(() => {
    return [...properties]
      .sort((a, b) => a.length - b.length || a.localeCompare(b))
      .map((param) => ({
        value: `{${param}}`,
        label: param,
      }));
  }, [properties]);

  return <Mentions prefix={PREFIX} split="" options={options} {...rest} />;
}
